import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Game} from "../Game";
import {gsap} from "gsap";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {WinRunner} from "../presentationRunner/WinRunner";
import {FSOutroRunner} from "../presentationRunner/FSOutroRunner";
import {SFSOutroRunner} from "../presentationRunner/SFSOutroRunner";
import {FSIntroRunner} from "../presentationRunner/FSIntroRunner";
import {SFSIntroRunner} from "../presentationRunner/SFSIntroRunner";
import {TotalWinRunner} from "../presentationRunner/TotalWinRunner";
import {EnhancerRunner} from "../presentationRunner/EnhancerRunner";
import {XWaysRevealRunner} from "../presentationRunner/XWaysRevealRunner";
import {BigWinRunner} from "../presentationRunner/BigWinRunner";
import {SplitRunner} from "../presentationRunner/SplitRunner";
import {S2RevealRunner} from "../presentationRunner/S2RevealRunner";
import {WinCapRunner} from "../presentationRunner/WinCapRunner";
import {NudgeStepRunner} from "../presentationRunner/NudgeStepRunner";
import {XHoleRunner} from "../presentationRunner/XHoleRunner";
import {CFSIntroRunner} from "../presentationRunner/CFSIntroRunner";
import {CFSOutroRunner} from "../presentationRunner/CFSOutroRunner";
import {XGodRunner} from "../presentationRunner/XGodRunner";
import {XMentalIntroRunner} from "../presentationRunner/XMentalIntroRunner";
import {XMentalOutroRunner} from "../presentationRunner/XMentalOutroRunner";
import {UpgradeRunner} from "../presentationRunner/UpgradeRunner";
import {DeadReveal} from "../presentationRunner/DeadReveal";

export class WinPresentation implements FlowStatePresentation {
    private readonly _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;

    constructor() {
        this._presentations = [
            new XGodRunner(),
            new S2RevealRunner(),
            new EnhancerRunner(),
            new NudgeStepRunner(),
            new SplitRunner(),
            new XWaysRevealRunner(),
            new DeadReveal(),
            new XHoleRunner(),
            new WinRunner(),
            new BigWinRunner(),
            new WinCapRunner(),
            new TotalWinRunner(),
            new UpgradeRunner(),
            new XMentalIntroRunner(),
            new FSIntroRunner(),
            new CFSIntroRunner(),
            new SFSIntroRunner(),
            new XMentalOutroRunner(),
            new FSOutroRunner(),
            new CFSOutroRunner(),
            new SFSOutroRunner()
        ];
    }

    public start(flowStateController: FlowStateController) {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private complete(): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => Game.keypadPlugin.setWin(Game.model.gameData.accumulatedRoundWin, true, Game.isWinBelowStake()));
        tl.add(() => {
            this._flowStateController.finish();
        });
    }
}